import BaseValidator from 'services/validations/base-validator';
import {groupObjectsByProp} from 'helpers/array-helper';

export default class MaxPlayersFromOneTeamValidator extends BaseValidator {
    private maxSingleTeamPlayers: number = 0;

    protected runValidation(): void {
        // @ts-ignore
        const {sportConfig} = this.dependencies;

        this.maxSingleTeamPlayers = sportConfig.getConfigProp('maxSingleTeamPlayers', 0);

        if (this.isSingleTeamPlayersQuantityExceeded()) {
            this.addError(`The max single team players is ${this.maxSingleTeamPlayers}.`);
        }
    }

    private isSingleTeamPlayersQuantityExceeded(): boolean {
        const maxSingleTeamPlayersInEditedLineup = this.calcMaxSingleTeamPlayersInEditedLineup();

        return maxSingleTeamPlayersInEditedLineup > this.maxSingleTeamPlayers;
    }

    private calcMaxSingleTeamPlayersInEditedLineup(): number {
        // @ts-ignore
        const {lineupPlayers} = this.dependencies;

        const teams = groupObjectsByProp(lineupPlayers, 'team');

        let max = 0;
        Object.values(teams).map((team) => {
            if (team.length > max) {
                max = team.length;
            }
        });

        return max;
    }
}
